// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".560.0.0." + {2239: "9c52c4fe9e74dc9e",2733: "0f03afdb1b74a31a",2944: "2c07c85167b18bcb",5233: "698ec7ae4e4dddbc",5338: "b2cc514015f72125",8756: "30e8f8ba46b2c6e0",9289: "7bb9ce34d7a7e7ba",}[chunkId] + ".css"
}